import React, { useState } from 'react';

export default function BuiltFileDropzone({
  accept,
  ariaLabel,
  className = '',
  dragActiveClassName = 'built-file-dropzone-active',
  disabled = false,
  onFile,
  children,
}) {
  const [isDragActive, setIsDragActive] = useState(false);

  const chooseFile = (files) => {
    if (disabled) return;
    const file = files?.[0];
    if (file) onFile(file);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) setIsDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!event.currentTarget.contains(event.relatedTarget)) setIsDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragActive(false);
    chooseFile(event.dataTransfer?.files);
  };

  return (
    <label
      className={`${className}${isDragActive ? ` ${dragActiveClassName}` : ''}`}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        type="file"
        accept={accept}
        aria-label={ariaLabel}
        className="stock-admin-file-input"
        disabled={disabled}
        onChange={(event) => {
          chooseFile(event.target.files);
          event.target.value = '';
        }}
      />
      {typeof children === 'function' ? children({ isDragActive }) : children}
    </label>
  );
}
